module.exports = __webpack_public_path__ + "img/vedio.d94bbdde.svg";